import React, { useState, useEffect } from 'react';
import {
  Switch,
  Redirect,
  Route,
  useLocation,
} from 'react-router-dom';

import { useConfig } from '../ConfigContext';
import { Account } from '../account/Account';
import { ProvideSnackbar } from '../snackbar/SnackbarContext';
import { Header } from '../header/Header';
import { Footer } from '../footer/Footer';
import { Authentication } from '../authentication/Authentication';
import { Register } from '../authentication/register/Register';
import { ProvideAuthentication } from '../authentication/AuthenticationContext';
import { GuardRoute } from '../_shared/GuardRoute';
import { ReCaptcha } from '../_shared/ReCaptcha';
import { CookieConsent } from '../cookie-consent/CookieConsent';
import { ProvideRedirectUrl } from '../redirect-url/ProviderRedirectUrlContext';
import { SteamRedirect } from '../account/providers/steam/SteamRedirect';
import { ForgotPassword } from '../authentication/forgot-password/ForgotPassword';
import { TwitchRedirect } from '../authentication/providers/twitch-button/TwitchRedirect';
import { MymWelcomePage } from '../account/my-games/mym-game/MymWelcome';
import { ProvideGameTheme } from '../GameThemeContext';
import { Activation } from '../activation/Activation';
import { ReferralCodeManagerPage } from '../referral/ReferralCodeManagerPage';
import { CommunicationPreferences } from '../account/communication-preferences/CommunicationPreferences';

export function BasePage(): JSX.Element {
  const config = useConfig();
  const location = useLocation();
  const [isReCaptchaLoaded, setIsReCaptchaLoaded] = useState(false);

  const handleReCaptchaLoaded = (isLoaded: boolean): void => {
    setIsReCaptchaLoaded(isLoaded);
  };

  useEffect(() => {
    if (location.search && location.pathname === '/mym/beta') {
      const { search } = location;
      const params = new URLSearchParams(search);

      if (
        params.get('utm_source')
        || params.get('utm_medium')
        || params.get('utm_campaign')
        || params.get('utm_campaignId')
        || params.get('utm_adId')
      ) {
        const query = {
          utmSource: params.get('utm_source') || '',
          utmMedium: params.get('utm_medium') || '',
          campaignName: params.get('utm_campaign') || '',
          campaignId: params.get('utm_campaignId') || '',
          adId: params.get('utm_adId') || '',
        };
        sessionStorage.setItem('userAdsTrackingData', JSON.stringify(query));
      }
    }
  }, [location]);

  return (
    <div className='app-container'>
      {config.isClientConfigLoad && config.isServerConfigLoad
        && (
          <>
            <Header />
            {((isReCaptchaLoaded && config.clientConfig?.recaptchaEnabled)
            || !config.clientConfig?.recaptchaEnabled)
            && (
              <div className='route-container'>
                <ProvideSnackbar>
                  <ProvideRedirectUrl>
                    <ProvideGameTheme>
                      <ProvideAuthentication>
                        <Switch>
                          <GuardRoute path='/auth' authRoute={false}>
                            <Authentication />
                          </GuardRoute>
                          <GuardRoute path='/register/:gameId?' authRoute={false}>
                            <Register />
                          </GuardRoute>
                          <GuardRoute path='/forgot-password/:gameId?' authRoute={false}>
                            <ForgotPassword />
                          </GuardRoute>
                          <Route
                            path='/account/activate-game/1866180'
                            exact
                          >
                            <Redirect to='/account/my-account/games/hoy/activation?provider=steam' />
                          </Route>
                          <Route
                            path='/account/my-account/games/:gameId/activation'
                            exact
                          >
                            <Activation />
                          </Route>
                          <Route path='/unsubscribe' exact>
                            <CommunicationPreferences noAuth />
                          </Route>
                          <GuardRoute path='/account' authRoute>
                            <Account />
                          </GuardRoute>
                          <Route path='/mym/beta' exact>
                            <MymWelcomePage />
                          </Route>
                          {/* TODO: to be deleted when v2 will be live and steam will be configured */}
                          <Route path='/provider/steam/redirect' exact>
                            <SteamRedirect />
                          </Route>
                          <Route path='/provider/twitch/redirect' exact>
                            <TwitchRedirect />
                          </Route>
                          <GuardRoute path='/s/:referralCode' authRoute>
                            <ReferralCodeManagerPage />
                          </GuardRoute>
                          <Redirect to='/auth' />
                        </Switch>
                      </ProvideAuthentication>
                    </ProvideGameTheme>
                  </ProvideRedirectUrl>
                </ProvideSnackbar>
              </div>
            )}
            <Footer />
            <CookieConsent />
            {config.clientConfig?.recaptchaEnabled && (
              <ReCaptcha
                loaded={handleReCaptchaLoaded}
              />
            )}
          </>
        )}
    </div>
  );
}
